import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import { ScheduledSectionsQuery } from '../../course_scheduler/queries/scheduled_sections_query';
import { MultiSectionServant } from '../../course_scheduler/servants/multi_section_servant';
import { UnscheduledSectionServant } from '../../unscheduled_sections/servants/unscheduled_section_servant';
import { RegistrationAlertsServant } from '../../course_scheduler/servants/registration_alerts_servant';
import { GetTermCoursesandScheduledSectionsCommand } from '../../term_courses/commands/get_term_courses_and_scheduled_sections_command';
import { UpdateSectionSelectedFlagCommand } from '../../unscheduled_sections/commands/update_section_selected_flag_command';
import { GetCrossCourseLinkedSectionsCommand } from '../../../components/section_corequisite/commands/get_cross_course_linked_sections_command';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';

export class ScheduleSectionFacade {
  constructor(
    private updateSectionSelectedFlagCommand: UpdateSectionSelectedFlagCommand,
    private ngUnscheduledSectionServant: UnscheduledSectionServant,
    private ngRegistrationAlertsServant: RegistrationAlertsServant,
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private scheduleSectionCommand: ICommand,
    private getCourseSchedulerCommand: ICommand,
    private ngScheduledSectionsQuery: ScheduledSectionsQuery,
    private ngSectionsDatasource: ISectionsDatasource,
    private updateSeatAvailabilityCommand: ICommand,
    private loadStudentUnavailabilityCommand: ICommand,
    private calendarPreviewRemoveSections: ICommand,
    private ngMultiSectionServant: MultiSectionServant,
    private getCrossCourseLinkedSectionsCommand: GetCrossCourseLinkedSectionsCommand,
    private getTermCoursesandScheduledSectionsCommand: GetTermCoursesandScheduledSectionsCommand
  ) {}

  scheduleSection(section: ISection, redirectAfterSchedule: boolean = true) {
    const isConflictingSection = this.ngUnscheduledSectionServant.isSectionConflicting(section);
    const includePopulateSatisfaction = true;

    return this.getCrossCourseLinkedSectionsCommand(section.id, includePopulateSatisfaction)
      .then(() => this.scheduleSectionCommand(this.$state.params.termId, section.id))
      .then(() => this.getTermCoursesandScheduledSectionsCommand(this.$stateParams.termId))
      .then(() => this.updateSectionSelectedFlagCommand(section.id))
      .then(() => {
        const _section = this.ngSectionsDatasource.metasource().compose(section.id);
        if (_section) {
          this.ngRegistrationAlertsServant.showScheduledAlerts([_section]);
        }
        if (isConflictingSection && this.ngUnscheduledSectionServant.isSectionConflictingWithBusyTimes(section)) {
          this.loadStudentUnavailabilityCommand(this.$stateParams.termId);
        }
        if (redirectAfterSchedule) {
          this.redirectAfterSchedule(section);
        }
        // TODO: Fix the issue of showing the scheduled section in the alert as well as it is not showing the non scheduled sections
        this.ngRegistrationAlertsServant.showOtherRequiredSectionTypesAlert(section);

        return this.updateSeatAvailabilityCommand([section.id]);
      })
      .then(() => this.calendarPreviewRemoveSections());
  }
  redirectAfterSchedule(section: ISection) {
    const allSections = this.ngScheduledSectionsQuery.result.list;
    const hasRequiredUnscheduledSiblings = this.ngMultiSectionServant.hasUnscheduledRequiredSiblingSections(
      section,
      allSections
    );

    if (
      _4.includes(_4.get(this.$state, '__previousRoute__.state.name', ''), 'reschedule') &&
      hasRequiredUnscheduledSiblings
    ) {
      const rescheduleUrl = 'my.schedule.registration.reschedule';
      const rescheduleParams = {
        courseId: section.course
      };
      this.$state.go(rescheduleUrl, rescheduleParams);
    } else {
      this.$state.go('my.schedule.registration');
    }
  }
}
angular.module('capability-ng-scheduler').service('ngScheduleSectionFacade', ScheduleSectionFacade);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/facades/schedule_section_facade.ts